/**
 * meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 */

export default [
    {
      path: '/auth',
      component: () => import('@/views/pages/pc/Index'),
      children: [
        // Login
        {
          name: 'Login',
          path: '/login',
          meta: {
            title: '登陆'
          },
          component: () => import('@/views/pages/Login')
        },
        {
          name: 'WebLogin',
          path: '/web/login',
          meta: {
            title: '登陆'
          },
          component: () => import('@/views/pages/WebLogin')
        },
      ]
    },
    {
      path: '/mobile/auth',
      component: () => import('@/views/pages/mobile/Index'),
      children: [
        // Login
        {
          name: 'MobileLogin',
          path: '/mobile/login',
          meta: {
            title: '登陆'
          },
          component: () => import('@/views/pages/mobile/Login')
        }
      ]
    },
    {
      path: '/mobile',
      name: 'm_dashboard',
      redirect: '/m-dashboard',
      component: () => import('@/views/pages/mobile/dashboard/Index'),
      children: [
        {
          name: 'MDashboard',
          path: '/m-dashboard',
          meta: {
            navigation: true,
            title: '首页',
            auth: true,
          },
          component: () => import('@/views/pages/mobile/dashboard/Dashboard')
        },
        {
          name: 'MAppIndex',
          path: '/application-index',
          meta: {
            navigation: true,
            title: '工作台',
            auth: true,
          },
          component: () => import('@/views/pages/mobile/application/Index')
        },
        // {
        //   name: 'MPersonalIndex',
        //   path: '/personal',
        //   meta: {
        //     navigation: true,
        //     title: '个人中心',
        //     auth: true,
        //     notCache: true
        //   },
        //   component: () => import('@/views/pages/pc/dashboard/personal/Index')
        // },
        {
          name: 'MInduction',
          path: '/induction',
          meta: {
            navigation: true,
            title: '入职申请',
            auth: true,
            notCache: true
          },
          component: () => import('@/views/pages/pc/office/induction/Index')
        },
        {
          name: 'MFollowAuditList',
          path: 'audit',
          redirect: 'audit/my-submit',
          meta: {
            navigation: true,
            title: '审核进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/audit/Index'),
          children: [
            {
              name: 'MMyAudit',
              path: 'my-audit',
              meta: {
                navigation: true,
                title: '待我审核',
                auth: true,
                icon: 'mdi-format-list-bulleted'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyAudit')
            },
            {
              name: 'MMySubmit',
              path: 'my-submit',
              meta: {
                navigation: true,
                title: '我的提交',
                auth: true,
                icon: 'mdi-upload'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MySubmit')
            },
            {
              name: 'MMyCopy',
              path: 'my-copy',
              meta: {
                navigation: true,
                title: '抄送给我',
                auth: true,
                icon: 'mdi-near-me'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyCopy')
            },
            {
              name: 'MMyRecord',
              path: 'my-record',
              meta: {
                navigation: true,
                title: '我审核的',
                auth: true,
                icon: 'mdi-pencil-outline'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyRecord')
            },
            {
              name: 'MMyExpire',
              path: 'my-expire',
              meta: {
                navigation: true,
                title: '超时待审',
                auth: true,
                icon: 'mdi-clipboard-text-clock-outline'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyExpire')
            }
          ]
        },
        {
          name: 'MPasswordReset',
          path: '/password',
          meta: {
            title: '密码重置'
          },
          component: () => import('@/views/pages/pc/dashboard/Password')
        },
        {
          name: 'MUserInfo',
          path: '/user',
          meta: {
            navigation: true,
            title: '个人中心'
          },
          component: () => import('@/views/pages/pc/dashboard/UserInfo')
        },
        {
          name: 'MSystemDept',
          path: 'system/system-dept',
          meta: {
            navigation: true,
            title: '组织架构',
            auth: true,
            icon: 'mdi-graph'
          },
          component: () => import('@/views/pages/pc/system/dept/Index')
        },
        {
          name: 'MSystemRole',
          path: 'system/system-role',
          meta: {
            navigation: true,
            title: '角色管理',
            auth: true,
            icon: 'mdi-link-variant'
          },
          component: () => import('@/views/pages/pc/system/role/Index')
        },
        {
          name: 'MSystemDictionary',
          path: 'system/system-dictionary',
          meta: {
            navigation: true,
            title: '数据字典',
            auth: true,
            icon: 'mdi-format-list-bulleted-type'
          },
          component: () => import('@/views/pages/pc/system/dictionary/Index')
        },
        {
          name: 'MSystemLog',
          path: 'system/system-log',
          meta: {
            navigation: true,
            title: '日志管理',
            auth: true,
            icon: 'mdi-math-log'
          },
          component: () => import('@/views/pages/pc/system/log/Index')
        },
        {
          name: 'MSettingPubpool',
          path: 'setting/setting-pubpool',
          redirect: 'setting/setting-pubpool/new-follow',
          meta: {
            navigation: true,
            title: '公海池配置',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/pubpoll/Index'),
          children: [
            {
              name: 'MNewFollow',
              path: 'new-follow',
              meta: {
                navigation: true,
                title: '无新建跟进客户配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/NewFollow')
            },
            {
              name: 'MCustomerNums',
              path: 'customer-nums',
              meta: {
                navigation: true,
                title: '最大客户数配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/CustomerNums')
            },
            {
              name: 'MCustomerFormer',
              path: 'former',
              meta: {
                navigation: true,
                title: '客户退回保护配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/Former')
            },
            {
              name: 'MCustomerFrequency',
              path: 'frequency',
              meta: {
                navigation: true,
                title: '每日可捞取配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/Frequency')
            }
          ]
        },
        {
          name: 'MSettingBankAccount',
          path: 'setting/setting-bank-account',
          meta: {
            navigation: true,
            title: '账户配置',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/bankAccount/Index')
        },
        {
          name: 'MSettingTarget',
          path: 'setting/setting-target',
          meta: {
            navigation: true,
            title: '目标管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/target/Index')
        },
        {
          name: 'MSettingWorkFlow',
          path: 'setting/setting-work-flow',
          meta: {
            navigation: true,
            title: '流程管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/workFlow/Index')
        },
        {
          name: 'MSettingReward',
          path: 'setting/setting-reward',
          meta: {
            navigation: true,
            title: '激励配置',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/reward/Index')
        },
        {
          name: 'MCustomerFollow',
          path: 'customer/customer-follow',
          meta: {
            navigation: true,
            title: '跟进记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/follow/Index')
        },
        {
          name: 'MCustomerFollowStatis',
          path: 'customer/customer-follow-statis',
          meta: {
            navigation: true,
            title: '跟进统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/follow/Statis')
        },
        {
          name: 'MPoolOrient',
          path: 'pool/pool-orient',
          meta: {
            navigation: true,
            title: '定向公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/orient/Index')
        },
        {
          name: 'MPoolPublicScreening',
          path: 'pool/pool-public-screening',
          meta: {
            navigation: true,
            title: '非定向公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/screening/Pool')
        },
        {
          name: 'MPoolScreening',
          path: 'pool/pool-screening',
          meta: {
            navigation: true,
            title: '个人公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/screening/Index')
        },
        {
          name: 'MPoolLibrary',
          path: 'pool/pool-library',
          meta: {
            navigation: true,
            title: '企业公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/library/Index')
        },
        {
          name: 'MCustomerContactsPersion',
          path: 'customer/customer-contacts-persion',
          meta: {
            navigation: true,
            title: '联系人',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/contacts/Index')
        },
        {
          name: 'MCustomerIndex',
          path: 'customer/customer-index',
          meta: {
            navigation: true,
            title: '客户查询',
            auth: true
          },
          component: () => import('@/views/pages/mobile/customer/info/Index')
        },
        {
          name: 'MFinanceInvoiceAddress',
          path: 'finance/finance-invoice-address',
          meta: {
            navigation: true,
            title: '发票地址',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/iaddress/Index')
        },
        {
          name: 'MProductIndex',
          path: 'product/product-index',
          meta: {
            navigation: true,
            title: '产品查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/product/Index')
        },
        {
          name: 'MContractIndex',
          path: 'contract/contract-index',
          meta: {
            navigation: true,
            title: '合同订单',
            auth: true
          },
          component: () => import('@/views/pages/mobile/contract/info/Index')
        },
        {
          name: 'MContractInvoice',
          path: 'contract/contract-invoice',
          meta: {
            navigation: true,
            title: '发票查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/invoice/Index')
        },
        {
          name: 'MRefundIndex',
          path: 'contract/contract-refund',
          meta: {
            navigation: true,
            title: '合同退款',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/refund/Index')
        },
        {
          name: 'MOrderIndex',
          path: 'order/order-index',
          meta: {
            navigation: true,
            title: '工单查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/order/info/Index')
        },
        {
          name: 'MOrderStep',
          path: 'order/order-step',
          meta: {
            navigation: true,
            title: '工单进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/order/step/Index')
        },
        {
          name: 'MFinanceReturned',
          path: 'finance/finance-returned',
          meta: {
            navigation: true,
            title: '回款查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/returned/Index')
        },
        {
          name: 'MFinanceCollect',
          path: 'finance/finance-collect',
          meta: {
            navigation: true,
            title: '应收查询',
            auth: true
          },
          component: () => import('@/views/pages/mobile/contract/collect/Index')
        },
        {
          name: 'MMessageCustomer',
          path: 'message/message-customer',
          meta: {
            navigation: true,
            title: '客户消息',
            auth: true
          },
          component: () => import('@/views/pages/pc/message/customer/Index')
        },
        {
          name: 'MMessageContract',
          path: 'message/message-contract',
          meta: {
            navigation: true,
            title: '合同消息',
            auth: true
          },
          component: () => import('@/views/pages/pc/message/contract/Index')
        },
        {
          name: 'MMessageCollect',
          path: 'message/message-collect',
          meta: {
            navigation: true,
            title: '收款提醒',
            auth: true
          },
          component: () => import('@/views/pages/pc/message/collect/Index')
        },
        {
          name: 'MScheduleJob',
          path: 'schedule/schedule-job',
          meta: {
            navigation: true,
            title: '任务管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/schedule/job/Index')
        },
        {
          name: 'MScheduleLog',
          path: 'schedule/schedule-log',
          meta: {
            navigation: true,
            title: '任务日志',
            auth: true
          },
          component: () => import('@/views/pages/pc/schedule/log/Index')
        },
        {
          name: 'MDataSelfPool',
          path: 'data/data-self-pool',
          meta: {
            navigation: true,
            title: '个海统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/data/SelfPool')
        },
        {
          name: 'MStatisYear',
          path: 'statis/statis-year',
          meta: {
            navigation: true,
            title: '年度统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/statis/year/Index')
        },
        {
          name: 'MStatisMonth',
          path: 'statis/statis-month',
          meta: {
            navigation: true,
            title: '月度统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/statis/month/Index')
        },
        {
          name: 'MStatisTarget',
          path: 'statis/statis-target',
          meta: {
            navigation: true,
            title: '目标统计',
            auth: true,
            notCache: true
          },
          component: () => import('@/views/pages/pc/statis/target/Index')
        },
        {
          name: 'MStatisRequest',
          path: 'statis/statis-request',
          meta: {
            navigation: true,
            title: '请求统计',
            auth: true,
            notCache: true,
            icon: 'mdi-cursor-default-gesture'
          },
          component: () => import('@/views/pages/pc/statis/request/Index')
        },
        {
          name: 'MStatisCustomer',
          path: 'statis/statis-customer',
          meta: {
            navigation: true,
            title: '客户统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/statis/customer/Index')
        },
        {
          name: 'MDashboardTableCustomer',
          path: 'dashboard/table/customer',
          meta: {
            navigation: true,
            title: '即将退回公海客户',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/table/CustomerList')
        },
        {
          name: 'MDashboardTableContract',
          path: 'dashboard/table/contract',
          meta: {
            navigation: true,
            title: '合同列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/table/ContractList')
        },
        {
          name: 'MDashboardTableCollect',
          path: 'dashboard/table/collect',
          meta: {
            navigation: true,
            title: '待收款列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/table/CollectList')
        },
        {
          name: 'MPatentIndex',
          path: 'patent/patent-index',
          meta: {
            navigation: true,
            title: '专利查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/info/Index')
        },
        {
          name: 'MPatentStep',
          path: 'patent/patent-step',
          meta: {
            navigation: true,
            title: '专利进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/step/Index')
        },
        {
          name: 'MPatentReduction',
          path: 'patent/patent-reduction',
          meta: {
            navigation: true,
            title: '专利费减',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/reduction/Index')
        },
        {
          name: 'MPatentCost',
          path: 'patent/patent-cost',
          meta: {
            navigation: true,
            title: '专利缴费',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/cost/Index')
        },
        {
          name: 'MPatentStatis',
          path: 'patent/patent-statis',
          meta: {
            navigation: true,
            title: '专利统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/statis/Index')
        },
        {
          name: 'MSoftwareIndex',
          path: 'software/software-index',
          meta: {
            navigation: true,
            title: '软著查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/software/Index')
        },
        {
          name: 'MSoftwareStep',
          path: 'software/software-step',
          meta: {
            navigation: true,
            title: '软著进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/software/step/Index')
        },
        {
          name: 'MTrademarkIndex',
          path: 'trademark/trademark-index',
          meta: {
            navigation: true,
            title: '商标查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/trademark/Index')
        },
        {
          name: 'MTrademarkStep',
          path: 'trademark/trademark-step',
          meta: {
            navigation: true,
            title: '商标进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/trademark/step/Index')
        },
        {
          name: 'MSettleSoftware',
          path: 'settle/settle-software',
          meta: {
            navigation: true,
            title: '软著结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/software/settle/Index')
        },
        {
          name: 'MPolicyIndex',
          path: 'policy/policy-index',
          meta: {
            navigation: true,
            title: '政策查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/policy/info/Index')
        },
        {
          name: 'MPolicyMatching',
          path: 'policy/policy-matching',
          meta: {
            navigation: true,
            title: '政策匹配',
            auth: true
          },
          component: () => import('@/views/pages/pc/policy/matching/Index')
        },
        {
          name: 'MPolicyPushRecord',
          path: 'policy/policy-push-record',
          meta: {
            navigation: true,
            title: '推送记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/policy/push/Index')
        },
        {
          name: 'MWechatUser',
          path: 'wechat/wechat-user',
          meta: {
            navigation: true,
            title: '用户管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/wechat/info/Index')
        },
        {
          name: 'MWechatDemand',
          path: 'wechat/wechat-demand',
          meta: {
            navigation: true,
            title: '需求管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/wechat/demand/Index')
        },
        {
          name: 'MWechatCustomer',
          path: 'wechat/wechat-customer',
          meta: {
            navigation: true,
            title: '绑定客户',
            auth: true
          },
          component: () => import('@/views/pages/pc/wechat/customer/Index')
        },
        {
          name: 'MPatentPay',
          path: 'patent/patent-pay',
          meta: {
            navigation: true,
            title: '付费记录(专利)',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/pay/Index')
        },
        {
          name: 'MTrademarkPay',
          path: 'trademark/trademark-pay',
          meta: {
            navigation: true,
            title: '付费记录(商标)',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/trademark/pay/Index')
        },
        {
          name: 'MSettleAudit',
          path: 'settle/settle-audit',
          meta: {
            navigation: true,
            title: '审计结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/order/settle/AuditIndex')
        },
        {
          name: 'MPatentSettle',
          path: 'settle/settle-patent',
          meta: {
            navigation: true,
            title: '专利结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/settle/Index')
        },
        {
          name: 'MSettleCommission',
          path: 'settle/settle-commission',
          meta: {
            navigation: true,
            title: '提成结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/settle/Index')
        },
        {
          name: 'MNoticeIndex',
          path: 'notice/info',
          meta: {
            navigation: true,
            title: '公告列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/notice/Index')
        },
        {
          name: 'MDiscussIndex',
          path: 'discuss/info',
          meta: {
            navigation: true,
            title: '纪要列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/discuss/info/Index')
        },
        {
          name: 'MCallRecord',
          path: 'call/call-record',
          meta: {
            navigation: true,
            title: '通话记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/call/record/Index')
        },
        {
          name: 'MCallSetting',
          path: 'call/call-setting',
          meta: {
            navigation: true,
            title: '考核设置',
            auth: true
          },
          component: () => import('@/views/pages/pc/call/setting/Index')
        },
        {
          name: 'MCallStatis',
          path: 'call/call-statis',
          meta: {
            navigation: true,
            title: '通话统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/call/statis/Index')
        },
        {
          name: 'MMOfficeWorkSet',
          path: 'office/office-work-setting',
          meta: {
            navigation: true,
            title: '排班管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/setting/Index')
        },
        {
          name: 'MOfficeArchives',
          path: 'office/office-archives',
          meta: {
            navigation: true,
            title: '档案管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/archives/Index')
        },
        {
          name: 'MMOfficePenalty',
          path: 'office/office-penalty',
          meta: {
            navigation: true,
            title: '乐捐管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/penalty/Index')
        },
        {
          name: 'MMOfficeScore',
          path: 'office/office-score',
          meta: {
            navigation: true,
            title: '评分管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/score/Index')
        },
        {
          name: 'MMOfficeCheck',
          path: 'office/office-check-work',
          meta: {
            navigation: true,
            title: '考勤管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/check/Index')
        },
        {
          name: 'MMOfficeSalarys',
          path: 'office/office-salary',
          meta: {
            navigation: true,
            title: '薪资管理',
            auth: true,
            icon: 'mdi-cursor-default-gesture'
          },
          component: () => import('@/views/pages/pc/office/salary/Index')
        },
        {
          name: 'MMOfficeAudit',
          path: 'office/office-audit',
          meta: {
            navigation: true,
            title: '审批记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/audit/Index')
        }
      ]
    },

    //  pc
    {
      path: '/',
      name: '_dashboard',
      redirect: '/dashboard',
      component: () => import('@/views/pages/pc/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '/dashboard',
          meta: {
            title: '工作台',
            auth: true,
            notCache: true
          },
          component: () => import('@/views/pages/pc/dashboard/Dashboard')
        },
        {
          name: 'PersonalIndex',
          path: '/personal',
          meta: {
            title: '个人中心',
            auth: true,
            notCache: true
          },
          component: () => import('@/views/pages/pc/dashboard/personal/Index')
        },
        {
          name: 'Induction',
          path: '/induction',
          meta: {
            title: '入职申请',
            auth: true,
            notCache: true
          },
          component: () => import('@/views/pages/pc/office/induction/Index')
        },
        {
          name: 'FollowAuditList',
          path: 'audit',
          redirect: 'audit/my-submit',
          meta: {
            title: '审核进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/audit/Index'),
          children: [
            {
              name: 'MyAudit',
              path: 'my-audit',
              meta: {
                title: '待我审核',
                auth: true,
                icon: 'mdi-format-list-bulleted'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyAudit')
            },
            {
              name: 'MySubmit',
              path: 'my-submit',
              meta: {
                title: '我的提交',
                auth: true,
                icon: 'mdi-upload'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MySubmit')
            },
            {
              name: 'MyCopy',
              path: 'my-copy',
              meta: {
                title: '抄送给我',
                auth: true,
                icon: 'mdi-near-me'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyCopy')
            },
            {
              name: 'MyRecord',
              path: 'my-record',
              meta: {
                title: '我审核的',
                auth: true,
                icon: 'mdi-pencil-outline'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyRecord')
            },
            {
              name: 'MyExpire',
              path: 'my-expire',
              meta: {
                title: '超时待审',
                auth: true,
                icon: 'mdi-clipboard-text-clock-outline'
              },
              component: () => import('@/views/pages/pc/dashboard/audit/components/MyExpire')
            }
          ]
        },
        {
          name: 'PasswordReset',
          path: '/password',
          meta: {
            title: '密码重置'
          },
          component: () => import('@/views/pages/pc/dashboard/Password')
        },
        {
          name: 'UserInfo',
          path: '/user',
          meta: {
            title: '个人中心'
          },
          component: () => import('@/views/pages/pc/dashboard/UserInfo')
        },
        {
          name: 'SystemDept',
          path: 'system/system-dept',
          meta: {
            title: '组织架构',
            auth: true,
            icon: 'mdi-graph'
          },
          component: () => import('@/views/pages/pc/system/dept/Index')
        },
        {
          name: 'SystemRole',
          path: 'system/system-role',
          meta: {
            title: '角色管理',
            auth: true,
            icon: 'mdi-link-variant'
          },
          component: () => import('@/views/pages/pc/system/role/Index')
        },
        {
          name: 'SystemDictionary',
          path: 'system/system-dictionary',
          meta: {
            title: '数据字典',
            auth: true,
            icon: 'mdi-format-list-bulleted-type'
          },
          component: () => import('@/views/pages/pc/system/dictionary/Index')
        },
        {
          name: 'SystemLog',
          path: 'system/system-log',
          meta: {
            title: '日志管理',
            auth: true,
            icon: 'mdi-math-log'
          },
          component: () => import('@/views/pages/pc/system/log/Index')
        },
        {
          name: 'SettingPubpool',
          path: 'setting/setting-pubpool',
          redirect: 'setting/setting-pubpool/new-follow',
          meta: {
            title: '公海池配置',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/pubpoll/Index'),
          children: [
            {
              name: 'NewFollow',
              path: 'new-follow',
              meta: {
                title: '无新建跟进客户配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/NewFollow')
            },
            {
              name: 'CustomerNums',
              path: 'customer-nums',
              meta: {
                title: '最大客户数配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/CustomerNums')
            },
            {
              name: 'CustomerFormer',
              path: 'former',
              meta: {
                title: '客户退回保护配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/Former')
            },
            {
              name: 'CustomerFrequency',
              path: 'frequency',
              meta: {
                title: '每日可捞取配置',
                auth: true,
                icon: 'md-home'
              },
              component: () => import('@/views/pages/pc/setting/pubpoll/components/Frequency')
            }
          ]
        },
        {
          name: 'SettingBankAccount',
          path: 'setting/setting-bank-account',
          meta: {
            title: '账户配置',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/bankAccount/Index')
        },
        {
          name: 'SettingTarget',
          path: 'setting/setting-target',
          meta: {
            title: '目标管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/target/Index')
        },
        {
          name: 'SettingWorkFlow',
          path: 'setting/setting-work-flow',
          meta: {
            title: '流程管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/workFlow/Index')
        },
        {
          name: 'SettingReward',
          path: 'setting/setting-reward',
          meta: {
            title: '激励配置',
            auth: true
          },
          component: () => import('@/views/pages/pc/setting/reward/Index')
        },
        {
          name: 'CustomerFollow',
          path: 'customer/customer-follow',
          meta: {
            title: '跟进记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/follow/Index')
        },
        {
          name: 'CustomerFollowStatis',
          path: 'customer/customer-follow-statis',
          meta: {
            title: '跟进统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/follow/Statis')
        },
        {
          name: 'PoolOrient',
          path: 'pool/pool-orient',
          meta: {
            title: '定向公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/orient/Index')
        },
        {
          name: 'PoolPublicScreening',
          path: 'pool/pool-public-screening',
          meta: {
            title: '非定向公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/screening/Pool')
        },
        {
          name: 'PoolScreening',
          path: 'pool/pool-screening',
          meta: {
            title: '个人公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/screening/Index')
        },
        {
          name: 'PoolLibrary',
          path: 'pool/pool-library',
          meta: {
            title: '企业公海',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/library/Index')
        },
        {
          name: 'CustomerContactsPersion',
          path: 'customer/customer-contacts-persion',
          meta: {
            title: '联系人',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/contacts/Index')
        },
        {
          name: 'CustomerIndex',
          path: 'customer/customer-index',
          meta: {
            title: '客户查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/info/Index')
        },
        {
          name: 'CustomerWeb',
          path: 'customer/customer-web',
          meta: {
            navigation: true,
            title: '网站管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/web/Index')
        },
        {
          name: 'FinanceInvoiceAddress',
          path: 'finance/finance-invoice-address',
          meta: {
            title: '发票地址',
            auth: true
          },
          component: () => import('@/views/pages/pc/customer/iaddress/Index')
        },
        {
          name: 'ProductIndex',
          path: 'product/product-index',
          meta: {
            title: '产品查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/product/Index')
        },
        {
          name: 'ContractIndex',
          path: 'contract/contract-index',
          meta: {
            title: '合同订单',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/info/Index')
        },
        {
          name: 'ContractMediator',
          path: 'contract/contract-mediator',
          meta: {
            navigation: true,
            title: '居间费',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/mediator/Index')
        },
        {
          name: 'ContractOther',
          path: 'contract/contract-other',
          meta: {
            navigation: true,
            title: '其他费用',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/other/Index')
        },
        {
          name: 'ContractInvoice',
          path: 'contract/contract-invoice',
          meta: {
            title: '发票查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/invoice/Index')
        },
        {
          name: 'RefundIndex',
          path: 'contract/contract-refund',
          meta: {
            title: '合同退款',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/refund/Index')
        },
        {
          name: 'OrderIndex',
          path: 'order/order-index',
          meta: {
            title: '工单查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/order/info/Index')
        },
        {
          name: 'OrderStep',
          path: 'order/order-step',
          meta: {
            title: '工单进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/order/step/Index')
        },
        {
          name: 'FinanceReturned',
          path: 'finance/finance-returned',
          meta: {
            title: '回款查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/returned/Index')
        },
        {
          name: 'FinanceCollect',
          path: 'finance/finance-collect',
          meta: {
            title: '应收查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/collect/Index')
        },
        {
          name: 'FinanceCommissionCheckIndex',
          path: 'finance/finance-commission-check',
          meta: {
            navigation: true,
            title: '提成核算',
            auth: true
          },
          component: () => import('@/views/pages/pc/finance/commission/check/Index')
        },
        {
          name: 'MessageCustomer',
          path: 'message/message-customer',
          meta: {
            title: '客户消息',
            auth: true
          },
          component: () => import('@/views/pages/pc/message/customer/Index')
        },
        {
          name: 'MessageContract',
          path: 'message/message-contract',
          meta: {
            title: '合同消息',
            auth: true
          },
          component: () => import('@/views/pages/pc/message/contract/Index')
        },
        {
          name: 'MessageCollect',
          path: 'message/message-collect',
          meta: {
            title: '收款提醒',
            auth: true
          },
          component: () => import('@/views/pages/pc/message/collect/Index')
        },
        {
          name: 'ScheduleJob',
          path: 'schedule/schedule-job',
          meta: {
            title: '任务管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/schedule/job/Index')
        },
        {
          name: 'ScheduleLog',
          path: 'schedule/schedule-log',
          meta: {
            title: '任务日志',
            auth: true
          },
          component: () => import('@/views/pages/pc/schedule/log/Index')
        },
        {
          name: 'DataSelfPool',
          path: 'data/data-self-pool',
          meta: {
            title: '个海统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/data/SelfPool')
        },
        {
          name: 'StatisYear',
          path: 'statis/statis-year',
          meta: {
            title: '年度统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/statis/year/Index')
        },
        {
          name: 'StatisMonth',
          path: 'statis/statis-month',
          meta: {
            title: '月度统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/statis/month/Index')
        },
        {
          name: 'StatisTarget',
          path: 'statis/statis-target',
          meta: {
            title: '目标统计',
            auth: true,
            notCache: true
          },
          component: () => import('@/views/pages/pc/statis/target/Index')
        },
        {
          name: 'StatisProffer',
          path: 'statis/statis-proffer',
          meta: {
            title: '贡献统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/statis/proffer/Index')
        },
        {
          name: 'StatisRequest',
          path: 'statis/statis-request',
          meta: {
            title: '请求统计',
            auth: true,
            notCache: true,
            icon: 'mdi-cursor-default-gesture'
          },
          component: () => import('@/views/pages/pc/statis/request/Index')
        },
        {
          name: 'StatisCustomer',
          path: 'statis/statis-customer',
          meta: {
            title: '客户统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/statis/customer/Index')
        },
        {
          name: 'DashboardTableCustomer',
          path: 'dashboard/table/customer',
          meta: {
            title: '即将退回公海客户',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/table/CustomerList')
        },
        {
          name: 'DashboardTableContract',
          path: 'dashboard/table/contract',
          meta: {
            title: '合同列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/table/ContractList')
        },
        {
          name: 'DashboardTableCollect',
          path: 'dashboard/table/collect',
          meta: {
            title: '待收款列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/dashboard/table/CollectList')
        },
        {
          name: 'PatentIndex',
          path: 'patent/patent-index',
          meta: {
            title: '专利查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/info/Index')
        },
        {
          name: 'PatentStep',
          path: 'patent/patent-step',
          meta: {
            title: '专利进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/step/Index')
        },
        {
          name: 'PatentReduction',
          path: 'patent/patent-reduction',
          meta: {
            title: '专利费减',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/reduction/Index')
        },
        {
          name: 'PatentCost',
          path: 'patent/patent-cost',
          meta: {
            title: '专利缴费',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/cost/Index')
        },
        {
          name: 'PatentStatis',
          path: 'patent/patent-statis',
          meta: {
            title: '专利统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/statis/Index')
        },
        {
          name: 'PatentSale',
          path: 'patent/patent-sale',
          meta: {
            title: '专利运营',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/sale/Index')
        },
        {
          name: 'SoftwareIndex',
          path: 'software/software-index',
          meta: {
            title: '软著查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/software/Index')
        },
        {
          name: 'SoftwareStep',
          path: 'software/software-step',
          meta: {
            title: '软著进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/software/step/Index')
        },
        {
          name: 'TrademarkIndex',
          path: 'trademark/trademark-index',
          meta: {
            title: '商标查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/trademark/Index')
        },
        {
          name: 'TrademarkStep',
          path: 'trademark/trademark-step',
          meta: {
            title: '商标进度',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/trademark/step/Index')
        },
        {
          name: 'SettleSoftware',
          path: 'settle/settle-software',
          meta: {
            title: '软著结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/software/settle/Index')
        },
        {
          name: 'PolicyIndex',
          path: 'policy/policy-index',
          meta: {
            title: '政策查询',
            auth: true
          },
          component: () => import('@/views/pages/pc/policy/info/Index')
        },
        {
          name: 'PolicyMatching',
          path: 'policy/policy-matching',
          meta: {
            title: '政策匹配',
            auth: true
          },
          component: () => import('@/views/pages/pc/policy/matching/Index')
        },
        {
          name: 'PolicyPushRecord',
          path: 'policy/policy-push-record',
          meta: {
            title: '推送记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/policy/push/Index')
        },
        {
          name: 'WechatUser',
          path: 'wechat/wechat-user',
          meta: {
            title: '用户管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/wechat/info/Index')
        },
        {
          name: 'WechatDemand',
          path: 'wechat/wechat-demand',
          meta: {
            title: '需求管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/wechat/demand/Index')
        },
        {
          name: 'WechatCustomer',
          path: 'wechat/wechat-customer',
          meta: {
            title: '绑定客户',
            auth: true
          },
          component: () => import('@/views/pages/pc/wechat/customer/Index')
        },
        {
          name: 'PatentPay',
          path: 'patent/patent-pay',
          meta: {
            title: '付费记录(专利)',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/pay/Index')
        },
        {
          name: 'TrademarkPay',
          path: 'trademark/trademark-pay',
          meta: {
            title: '付费记录(商标)',
            auth: true
          },
          component: () => import('@/views/pages/pc/copyright/trademark/pay/Index')
        },
        {
          name: 'SettleAudit',
          path: 'settle/settle-audit',
          meta: {
            title: '审计结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/order/settle/AuditIndex')
        },
        {
          name: 'PatentSettle',
          path: 'settle/settle-patent',
          meta: {
            title: '专利结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/patent/settle/Index')
        },
        {
          name: 'SettleCommission',
          path: 'settle/settle-commission',
          meta: {
            title: '提成结算',
            auth: true
          },
          component: () => import('@/views/pages/pc/contract/settle/Index')
        },
        {
          name: 'NoticeIndex',
          path: 'notice/info',
          meta: {
            title: '公告列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/notice/Index')
        },
        {
          name: 'DiscussIndex',
          path: 'discuss/info',
          meta: {
            title: '纪要列表',
            auth: true
          },
          component: () => import('@/views/pages/pc/discuss/info/Index')
        },
        {
          name: 'CallRecord',
          path: 'call/call-record',
          meta: {
            title: '通话记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/call/record/Index')
        },
        {
          name: 'CallSetting',
          path: 'call/call-setting',
          meta: {
            title: '考核设置',
            auth: true
          },
          component: () => import('@/views/pages/pc/call/setting/Index')
        },
        {
          name: 'CallStatis',
          path: 'call/call-statis',
          meta: {
            title: '通话统计',
            auth: true
          },
          component: () => import('@/views/pages/pc/call/statis/Index')
        },
        {
          name: 'OfficeWorkSet',
          path: 'office/office-work-setting',
          meta: {
            title: '排班管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/setting/Index')
        },
        {
          name: 'OfficeArchives',
          path: 'office/office-archives',
          meta: {
            title: '档案管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/archives/Index')
        },
        {
          name: 'OfficePenalty',
          path: 'office/office-penalty',
          meta: {
            title: '乐捐管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/penalty/Index')
        },
        {
          name: 'OfficeScore',
          path: 'office/office-score',
          meta: {
            title: '评分管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/score/Index')
        },
        {
          name: 'OfficeCheck',
          path: 'office/office-check-work',
          meta: {
            title: '考勤管理',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/check/Index')
        },
        {
          name: 'OfficeSalarys',
          path: 'office/office-salary',
          meta: {
            title: '薪资管理',
            auth: true,
            icon: 'mdi-cursor-default-gesture'
          },
          component: () => import('@/views/pages/pc/office/salary/Index')
        },
        {
          name: 'OfficeAudit',
          path: 'office/office-audit',
          meta: {
            title: '审批记录',
            auth: true
          },
          component: () => import('@/views/pages/pc/office/audit/Index')
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/views/pages/pc/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          meta: {
            title: '页面不存在'
          },
          component: () => import('@/views/pages/Error')
        }
      ]
    }
  ]
